<template>
    <tr :class="{ 'text-success' : (measurement.value.valid), 'text-danger' : (measurement.value.valid == false) }">

        <td>{{ measurement.definition.name }}</td> <!-- NAME -->
        <td> <div class="fa fa-info-circle" :title="measurement.definition.description || '' "></div> </td><!-- help from comment -->
        <td>{{ typeAndLimit }}</td><!-- TYPE -->

        <!-- VALUE -->
        <td>
            <textarea
                class="form-control border border-dark"
                rows="4"
                :maxlength="measurement.definition.max || false"
                v-model.trim="measurement.value.value"
                :placeholder="'Insert ' + measurement.definition.unit || 'No.'"
                v-if="(measurement.definition.type === 'string')"></textarea>
            <div v-else-if="(measurement.definition.type === 'bool')">
                <div class="form-check form-check-inline">
                    <input
                        class="form-check-input"
                        type="radio"
                        value="1"
                        v-model="measurement.value.value"
                        :name=" 'bool' + measurement.definition.id "
                        :checked="measurement.value.value == 1">
                    <label class="form-check-label">yes</label>
                </div>
                <div class="form-check form-check-inline">
                    <input
                        class="form-check-input"
                        type="radio"
                        value="0"
                        v-model="measurement.value.value"
                        :name=" 'bool' + measurement.definition.id "
                        :checked="measurement.value.value == 0">
                    <label class="form-check-label">no</label>
                </div>
            </div>
            <input
                type="number"
                class="form-control border border-dark"
                v-model.number="measurement.value.value"
                :min="knownMinimum"
                :max="knownMaximum"
                :step="knownStep"
                v-else-if="(measurement.definition.type === 'int' || measurement.definition.type === 'float')" />
            <select
                class="form-control border border-dark"
                v-model.trim="measurement.value.value"
                v-else-if="(measurement.definition.type === 'json')">
                <option v-for='(item) of measurement.definition.list.slice(2,-2).split("\",\"")' :value="item">{{ item }}</option>
            </select>
            <datepicker
                input-class="form-control"
                calendar-class="bg-skyblue"
                :bootstrap-styling="true"
                placeholder="Pick a date"
                :monday-first="true"
                format="yyyy-MM-dd"
                :use-utc="true"
                v-model="measurement.value.value"
                @input="changeDate"
                v-else-if="(measurement.definition.type === 'date')" >
            </datepicker>
            <p v-else>Unknown input type {{ measurement.definition.type }}</p>

            <div v-if="measurement.value.errors">

                <p v-if="measurement.value.errors.length === 0" class="text-success">{{ 'Data saved' }}</p>
                <p v-else v-for="item of measurement.value.errors" class="invalid-feedback" style="display:block;">{{ item }}</p>
               
            </div>
             
        </td>

        <td>{{ measurement.definition.unit || "no-unit" }}</td><!-- units -->
        <td> <div class="btn btn-white border border-dark" @click="clear()" title="clears value">Clear</div> </td><!-- CLEAR BUTTON -->
        <td>{{ measurement.definition.code || "/" }}</td>

        <!-- NOTE -->
        <td>
            <textarea
                rows="3"
                v-model="measurement.value.note"
                placeholder="Comment (not required)"
                class="form-control border border-dark"
                >
            </textarea>
        </td>
        <td>{{ measurement.value.updated_at || '' }}</td>

    </tr>
</template>

<script>
export default {
    props : {

        measurement : {
            type : Object,
            required : true,
        }

    },

    computed : {

        typeAndLimit() {
            let limits = "";
            if (this.measurement.definition.min != null || this.measurement.definition.max != null) {
                limits = " [";
                if (this.measurement.definition.min != null) {
                    limits += "min:" + this.measurement.definition.min + ", ";
                }
                if (this.measurement.definition.max != null) {
                    limits += "max:" + this.measurement.definition.max;
                }
                limits +="]";
            }

            switch (this.measurement.definition.type) {
                case "int" : return "number, without decimals" + limits;
                case "float" : return "number, can have decimals" + limits;
                case "string" : return "text" + limits;
                case "bool" : return " yes/no question" + limits;
                case "json" : return "pre-defined list of values";
                case "date" : return "date";
                default : alert("WTF, UNKNOWN INPUT TYPE " + this.measurement.definition.type);
            }
        },

        knownMinimum() {
            if (this.measurement.definition.type === "int" || this.measurement.definition.type === "float") {
                if (this.measurement.definition.min != null) return this.measurement.definition.min;
            }

            return false;
        },

        knownMaximum() {
            if (this.measurement.definition.type === "int" || this.measurement.definition.type === "float") {
                if (this.measurement.definition.max != null) return this.measurement.definition.max;
            }

            return false;
        },

        knownStep() {
            // TODO : check if we need any number of decimals or are 4 enough
            return  ((this.measurement.definition.type === "float") ? 0.00000001 : 1);
        }

    },

    methods: {

        changeDate() {
          
            this.measurement.value.value = this.measurement.value.value.toISOString().slice(0, 10);
        },

        clear() {
            this.measurement.value.value = null;
        },
    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/measurements-module/entry/EntryInput.vue